import { useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { Asterisk } from "@/components/UFO";

const FALLBACK_PHRASES = ["Escuchar es un acto político", "La música no se posee, se atraviesa", "Madrid suena", "Hecho con grano", "Una estrofa, mil silencios"];

export function Marquee() {
  const [phrases, setPhrases] = useState([]);
  useEffect(() => {
    api.get("/phrases").then((r) => setPhrases((r.data || []).map((p) => p.text).filter(Boolean))).catch(() => {});
  }, []);
  const list = useMemo(() => {
    const base = (phrases.length ? phrases : FALLBACK_PHRASES).slice();
    for (let i = base.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [base[i], base[j]] = [base[j], base[i]]; }
    return base;
  }, [phrases]);

  return (
    <section className="bg-[#1A1A1A] text-[#FAF9F6] py-6 overflow-hidden" data-testid="marquee-section">
      <div className="flex marquee-track whitespace-nowrap gap-12 items-center">
        {[...Array(2)].flatMap((_, i) =>
          list.map((t, j) => (
            <span key={`${i}-${j}`} className="display text-3xl md:text-4xl italic flex items-center gap-12" style={{ color: "#FAF9F6" }}>
              {t}
              <Asterisk size={20} color="#B4D844" />
            </span>
          ))
        )}
      </div>
    </section>
  );
}
